// import { EntrepreneurAnnounce10FormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurAnnounce10FormComponent";
// import { EntrepreneurCh24Announce10FormComponent } from "../../../components/SupportSystem/SupportForm/current/EntrepreneurCh24Announce10FormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { EntrepreneurCh24Announce10FormComponent } from "../../../components/SupportSystem/SupportForm/current/EntrepreneurCh24Anncounce10FormComponent";
// import { EntrepreneurCh24Announce10FormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurCh24Announce10FormComponent";

export function EntrepreneurCh24Announce10FormContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <EntrepreneurCh24Announce10FormComponent/>
            <Footer />
        </div>        
    )
    
}